import { green, white } from '../../../theme';

// high contrast colors
const COLORS = {
  error: {
    textColor: white,
    background: '#393939',
    main: '#fa4d56',
  },
  info: {
    textColor: white,
    background: '#393939',
    main: '#4086ee',
  },
  success: {
    textColor: white,
    background: '#393939',
    main: green,
  },
};

export const styles = {
  root: {
    display: 'flex',
    backgroundColor: props => COLORS[props.type].background,
    borderLeft: props => `3px solid ${COLORS[props.type].main}`,
    color: props => COLORS[props.type].textColor,
    padding: 15,
    width: 250,
  },
  title: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
    marginBottom: 5,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      fontSize: 14,
      lineHeight: '14px',
    },
  },
  leftIcon: {
    fontSize: 20,
    marginRight: 16,
    color: props => COLORS[props.type].main,
  },
  closeButton: {
    height: 20,
    width: 20,
    padding: 0,
    '& svg': {
      fill: props => COLORS[props.type].textColor,
    },
  },
};
